import { TranslateFunction } from '@wix/challenges-web-library';
import { State as ParticipantState } from '@wix/ambassador-challenges-v1-participant/types';

type ThankYouPageTextParams = {
  t: TranslateFunction;
  isJoined: boolean;
  isProviderPaymentPending: boolean;
  isNewProviderPaymentDescriptionEnabled?: boolean;
};

export function isProviderPaymentWaitingForAccess(
  paymentStatus?: string,
  participantState?: ParticipantState,
): boolean {
  return (
    paymentStatus === 'pending' &&
    !isParticipantAccessConfirmed(participantState)
  );
}

export function isParticipantAccessConfirmed(
  participantState?: ParticipantState,
): boolean {
  return [
    ParticipantState.JOINED,
    ParticipantState.RUNNING,
    ParticipantState.COMPLETED,
  ].includes(participantState);
}

export function getThankYouPageTitleText({
  t,
  isJoined,
  isProviderPaymentPending,
}: ThankYouPageTextParams): string {
  if (isProviderPaymentPending) {
    return t('challenge.participant.offline-payment-pending');
  }

  if (!isJoined) {
    return t('thank-you.page.secret.title');
  }

  return t('thank-you.page.title');
}

export function getThankYouPageDescriptionText({
  t,
  isJoined,
  isProviderPaymentPending,
  isNewProviderPaymentDescriptionEnabled,
}: ThankYouPageTextParams): string {
  if (isProviderPaymentPending) {
    return isNewProviderPaymentDescriptionEnabled
      ? t('thank-you.page.provider-payment-pending.description')
      : t('thank-you.page.secret.description');
  }

  if (!isJoined) {
    return t('thank-you.page.secret.description');
  }

  return t('thank-you.page.description');
}
